'use client';

import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { thisHostAndBasePath } from '../../../config';

const ExpandableSearch = dynamic(
  () => import('@carbon/react').then(m => m.ExpandableSearch),
  { ssr: false }
);

const delay = 1500;

type SearchProps = {
  searchPlaceholder: string;
};

function startsWith(allowList: string[], target: string): boolean {
  return allowList.some(prefix => target.startsWith(prefix));
}

declare global {
  interface Window {
    clientside?: {
      searchTarget?: string;
    };
  }
}

const Search: React.FC<SearchProps> = ({ searchPlaceholder }) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [mounted, setMounted] = useState(false);

  // Ensure client-only render
  useEffect(() => {
    setMounted(true);
  }, []);

  const headerSearch = (value: string) => {
    if (typeof window === 'undefined') return;

    const headerSearchAllowList = [
      'https://developer.ibm.com',
      'https://developer.ibm.com/callforcode',
    ];

    if (
      window.clientside?.searchTarget &&
      startsWith(headerSearchAllowList, window.clientside.searchTarget)
    ) {
      window.location.href = `${window.clientside.searchTarget}${encodeURIComponent(
        value
      )}`;
    } else {
      window.location.href = `${thisHostAndBasePath}/search/?q=${encodeURIComponent(
        value
      )}`;
    }
  };

  const searchCallback = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      if (!value.trim()) return;
      headerSearch(value);
    }, delay);
  };

  // ⛔ Prevent server render entirely
  if (!mounted) return null;

  return (
    <ExpandableSearch
      size="lg"
      placeholder={searchPlaceholder}
      labelText={searchPlaceholder}
      onChange={searchCallback}
      type="text"
      id="search-expandable-1"
    />
  );
};

export default Search;
